import useFormStore from '../state/useFormStore';

export const sleep = (ms: number) => new Promise((resolve) => {
  setTimeout(resolve, ms);
});

interface FormatCurrencyOptions {
  decimals?: number;
}

export const formatCurrency = (amount: number, options?: FormatCurrencyOptions): string => {
  const decimals = options?.decimals ?? 0; // Si no se especifica, usa 0 decimales

  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(amount);
};

export const parseLocalDate = (dateStr: string) => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export const clearLocalStorage = () => {
  const currentHash = useFormStore.getState().hash;
      if (currentHash) {
        localStorage.removeItem(`prestix_${currentHash}`);
      }
  localStorage.removeItem('auth_token');
  localStorage.removeItem('hash');
  localStorage.removeItem('selectedOfferId');
  localStorage.removeItem('selectedOfferResumen');
  localStorage.removeItem('userCBU');
}